/**
 * Constants module - Adyen-related constants
 * This module exports constants used throughout the Adyen integration
 */

module.exports = {
    // Payment method identifiers
    METHOD_ADYEN: 'Adyen',
    METHOD_ADYEN_POS: 'AdyenPOS',
    METHOD_ADYEN_COMPONENT: 'AdyenComponent',

    // Result codes
    RECEIVED: 'Received',
    NOTENOUGHBALANCE: 'NotEnoughBalance',
    SUCCESS: 'Success',

    // Payment method types
    GIFTCARD: 'giftcard',
    SCHEME: 'scheme',
    GIROPAY: 'giropay',
    APPLE_PAY: 'applepay',
    PAYPAL: 'paypal',
    AMAZON_PAY: 'amazonpay',
    GOOGLE_PAY: 'googlepay',
    CASHAPP: 'cashapp',
    UPI: 'upi',

    // Action types
    ACTIONTYPE: {
        QRCODE: 'qrCode'
    },

    // Payment methods that disable the submit button
    DISABLED_SUBMIT_BUTTON_METHODS: [
        'paypal',
        'paywithgoogle',
        'googlepay',
        'amazonpay',
        'applepay',
        'cashapp',
        'upi'
    ]
};
